// extracted by mini-css-extract-plugin
module.exports = {"container":"footer__container___2tyK9","is-mobile":"footer__is-mobile___1X3kr"};